import { Box, Button, Stack } from 'gantri-components';
import { useParams, Link } from 'react-router-dom';
import { useFetchDesign } from 'api/designs/routes';
import { Page } from 'core/page';
import { SimpleErrorBoundary } from 'components/simple-error-boundary';
import { formatDate } from 'utils/date';
import { routePaths } from 'src/app-routes';
import { ChecklistReviewList } from '../submit-concept/checklist-review-list';
import { StepHeader } from '../../components/step-header';
import { HeaderSubmissionDetails } from '../../components/step-header/components/header-submission-details';

export const ModelFeedbackPage = () => {
  const { id } = useParams<{ id: string }>();

  const { data } = useFetchDesign({
    fetchArgs: {
      id: Number(id),
    },
  });

  const design = data?.data;

  return (
    <Page>
      <SimpleErrorBoundary>
        <Box maxWidth="92rem">
          {design && (
            <Stack>
              <StepHeader design={design} showBackButton>
                <HeaderSubmissionDetails
                  descriptionProps={{
                    color: 'alert',
                    text: `Returned ${formatDate(
                      design.model.refinementsNeededAt,
                    )}`,
                  }}
                  imgProps={{ src: 'graphite/design-flow/icon-work_2x.png' }}
                  titleProps={{ text: 'Your model needs more work' }}
                >
                  <Link
                    to={routePaths.designFlowModelStep({
                      id: design.id,
                      stepNumber: 1,
                    })}
                  >
                    <Button size="large" text="Edit Design" />
                  </Link>
                </HeaderSubmissionDetails>
              </StepHeader>

              <Stack gap="6x">
                <ChecklistReviewList
                  list={design.model.review?.[1]?.sections}
                  showApprovedStatus
                />
              </Stack>
            </Stack>
          )}
        </Box>
      </SimpleErrorBoundary>
    </Page>
  );
};
